import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./stiluri/BaraCautare.css";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import RezultateCautare from "./RezultateCautare";
import { useTranslation } from "react-i18next";


const InputField = ({ name, type = "text", placeholder, value, onChange, onKeyPress, max }) => (
  <input
    type={type}
    name={name}
    placeholder={placeholder}
    className="form-control"
    value={value}
    onChange={onChange}
    onKeyPress={onKeyPress}
    max={max}
  />
);

const BaraCautare = () => {
  const [filters, setFilters] = useState({
    generalSearch: "",
    cnp: "",
    nume: "",
    prenume: "",
    dataNasterii: "",
    judet: "",
    oras: "",
    identitateGen: "",
  });
  const { t } = useTranslation();
  const [searchError, setSearchError] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [user, setUser] = useState(null);
  const [showSpecificSearch, setShowSpecificSearch] = useState(false);
  const navigate = useNavigate();
    const [loading, setLoading] = useState(false);  // <-- loading state


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setSearchError("");
  };

const handleSearch = async () => {
  if (!user) {
  setSearchError(t("mustBeLoggedIn"));
    return;
  }

  // Verificăm dacă există cel puțin un criteriu completat
  const hasCriteria = Object.values(filters).some(
    (value) => value && value.trim() !== ""
  );
  if (!hasCriteria) {
    setSearchError(t("mustBeLoggedIn"));
    return; // nu facem fetch
  }

  setLoading(true); // pornim loading
  setSearchError(""); // resetăm mesajul anterior

  try {
    const response = await fetch(
      "https://us-central1-epafa-production.cloudfunctions.net/cautaBeneficiariREST",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(filters),
      }
    );

    if (!response.ok) {
      throw new Error("Eroare la apelul REST: " + response.statusText);
    }

    const data = await response.json();

    if (data.length === 0) {
setSearchError(t("notFound"));
    } else {
      setSearchResults(data);
    }
  } catch (error) {
    console.error("Eroare la apelarea funcției REST:", error);
setSearchError(t("searchError"));  } finally {
    setLoading(false); // oprim loading indiferent de rezultat
  }
};


  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleResultClick = (id) => {
    navigate(`/Beneficiar/${id}`);
  };

  const handleReset = () => {
    setFilters({
      generalSearch: "",
      cnp: "",
      nume: "",
      prenume: "",
      dataNasterii: "",
      judet: "",
      oras: "",
      identitateGen: "",
    });
    setSearchResults([]);
    setSearchError("");
  };

  const campuriFiltre = [
    {
      name: "generalSearch",
      placeholder: t("generalSearchPlaceholder"),
      colClass: "col-12 mb-2",
      type: "text",
      showAlways: true,
    },
    {
      name: "nume",
      placeholder: t("lastName"),
      colClass: "col-12 col-md-3 mb-2",
    },
    {
      name: "prenume",
      placeholder: t("firstName"),
      colClass: "col-12 col-md-3 mb-2",
    },
    {
      name: "dataNasterii",
      placeholder: t("birthDate"),
      type: "date",
      max: new Date().toISOString().split("T")[0],
      colClass: "col-12 col-md-3 mb-2",
    },
    // Poți adăuga aici și alte câmpuri cum ar fi cnp, judet, oras, identitateGen
  ];

  return (
    <div className="container-fluid-dashboard">
      <div className="bara-cautare row">
        {campuriFiltre.map(({ name, placeholder, type = "text", max, colClass, showAlways }) => {
          if (!showAlways && !showSpecificSearch) return null;
          return (
            <div key={name} className={colClass}>
              <InputField
                name={name}
                placeholder={placeholder}
                type={type}
                max={max}
                value={filters[name]}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
            </div>
          );
        })}

        <div className="col-12 col-md-6 mt-2 button-container">
          <div className="button-group">
            <button className="btn btn-secondary btn-search" onClick={handleReset}>
                {t("reset")}
            </button>
            <button
              className="btn btn-secondary btn-search"
              onClick={() => setShowSpecificSearch(!showSpecificSearch)}
            >
              {showSpecificSearch ? "Ascunde Filtre" : "Filtre Avansate"}
            </button>
            <button
              className="btn btn-primary btn-search"
              onClick={handleSearch}
              disabled={loading} // dezactivează butonul la loading
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {t("searching")}...
                </>
              ) : (
                t("search")
              )}
            </button>
          </div>
        </div>
      </div>

      {searchError && (
        <div className="alert alert-danger mt-3" role="alert">
          {searchError}
        </div>
      )}

      <div className="col-12 mt-4">
        <RezultateCautare
          searchResults={searchResults}
          handleResultClick={handleResultClick}
        />
      </div>
    </div>
  );
};

export default BaraCautare;
